export default "__VITE_ASSET__UZyPOq0h__"